import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86bc13c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-title" }
const _hoisted_2 = { name: "header" }
const _hoisted_3 = { class: "wrapper-subtitle" }
const _hoisted_4 = { class: "wrapper-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "popUp",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
          class: "wrapper"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$localize('network.confirm.popup.title')), 1)
            ], true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('network.confirm.popup.warning1')) + " \"" + _toDisplayString(_ctx.caseToUnshare.title) + "\", " + _toDisplayString(_ctx.$localize('network.confirm.popup.warning2')), 1)
            ], true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "footer", {}, () => [
              _createElementVNode("a", {
                class: "btn btn-cancel",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, _toDisplayString(_ctx.$localize('network.confirm.popup.cancel')), 1),
              _createElementVNode("a", {
                class: "btn btn-delete",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('unshare')))
              }, _toDisplayString(_ctx.$localize('network.confirm.popup.confirm')), 1)
            ], true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}